<script lang="ts" setup>
import { onMounted, toRefs } from "vue";
import RegistrationForm from "@/app/registration-app/user/invited-registration/components/RegistrationForm/RegistrationForm.vue";
import type { Message } from "@/app/registration-app/user/invited-registration/@types/Message";
import { RegistrationType } from "@/shared/generated/graphql";
import { useGetRegistrationData } from "./useGetRegistrationData.composable";
import { useRegisterUser } from "./useRegisterUser.composable";

const props = defineProps<{
  provisioningKey: string;
  registrationType: RegistrationType;
}>();

const { provisioningKey, registrationType } = toRefs(props);

const emit = defineEmits<{
  (e: "show-message", value: Message): void;
  (e: "show-success"): void;
}>();

// --- Message ---
const showMessage = (message: Message) => {
  emit("show-message", message);
};

// --- Fetch Registration-Data ---
const {
  isFetchingRegistrationData,
  onFetchingRegistrationData,
  initialValues,
  finishedRegistration,
} = useGetRegistrationData(
  provisioningKey.value,
  registrationType.value,
  showMessage,
);

onMounted(() => onFetchingRegistrationData());

// --- Register Fleet@Home-User ---
const { isRegisteringUser, onRegisteringUser } = useRegisterUser(
  provisioningKey,
  registrationType,
  showMessage,
);
</script>

<template>
  <RegistrationForm
    v-if="!isFetchingRegistrationData"
    :initial-values="initialValues"
    :is-loading="isRegisteringUser"
    :registration-type="registrationType"
    :finished-registration="finishedRegistration"
    @register="onRegisteringUser"
  />
</template>
